import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { Minute } from '@nu-art/ts-common';
export const ApiDef_AdvisorATS = {
    api: {
        createAdvisorArtifact: { method: HttpMethod.POST, path: `v1/ats/create-advisor-artifact`, timeout: 2 * Minute },
    }
};
//# sourceMappingURL=types.js.map